import React from 'react';
import ImageCarussel from '../Image-Carussel/ImageCarussel';
import '../Welcome/WelcomePage.css'
import { Helmet } from 'react-helmet-async';





const WelcomeWelcome = () => {
    return (
        <>

            <Helmet>
                <title>Herzlich Willkommen</title>
                <meta name="description" content='Willkommen bei meiner Ernährungspraxis in Püttlingen/Saarland! 
                Seit 1995 biete ich individuelle Beratung vor Ort und seit 2020 auch bundesweit Online an. 
                Spezialisierung auf Nahrungsmittel-Allergien, Nahrungsmittel-Unverträglichkeiten, Magen-und Darmerkrankungen, Nierenerkrankungen, bariatrische Operationen.
                Meine Beratungen werden von den gesetzlichen Krankenkassen bezuschusst bzw. vollständig übernommen.' />
            </Helmet>

            <div className="WelcomePage">
                <div className="CompletePage">

                    <div className="WelcomePagePictures">
                        <ImageCarussel />

                    </div>
                    <div className='WelcomePageContent'>



                        <p className='Text'>
                        Herzlich Willkommen !<br></br><br></br>
                            Ich freue mich sehr, dass Sie sich für das Thema „ERNÄHRUNG“ interessieren und begrüße Sie ganz herzlich auf meiner Homepage.
                            In meiner Praxis für Ernährungsberatung und Ernährungstherapie in Püttlingen/ Saarland, biete ich seit 1995 eine kompetente, Produkt unabhängige und v.a. persönliche  und individuelle Ernährungsberatung und Ernährungstherapie an.
                            Seit 2020 biete ich auch  bundesweit Online-Ernährungsberatung und Online-Ernährungstherapie per Zoom oder Skype an. Beratungen per WhatsApp-Video-Chat oder telefonisch sind ebenfalls möglich.
                            Auch hier berate ich Sie persönlich und individuell und nicht per App oder vorgefertigten Plänen.
                            Ich orientiere mich an den Richtlinien der Deutschen Gesellschaft für Ernährung, berate Sie nach neuesten wissenschaftlichen Erkenntnissen und verkaufe Ihnen keine Produkte.
                            Spezialisiert habe ich mich in den Bereichen Nahrungsmittel-Allergien und Nahrungsmittel-Unverträglichkeiten, Magen-und Darmerkrankungen sowie Nierenerkrankungen.
                            Wenn Sie mit dem Gedanken einer bariatrischen Operation spielen, berate ich Sie auch hier sehr gerne nach neuesten wissenschaftlichen Erkenntnissen.
                            Aufgrund meiner Qualifikationen, meiner Zertifizierung beim VFED und DAAB und meiner ständigen Fortbildungen werden meine Beratungen von den Krankenkassen bezuschusst bzw. in vollem Umfang übernommen.
                            Gerne berate ich Sie vorab in einem für Sie kostenfreien telefonischen Informationsgespräch unter Tel.: 06898 63374 oder per Mail.
                            <br></br> <br></br>Ich freue mich auf Ihren Anruf bzw. ihre Nachricht!


                        </p>



                    </div>



                </div>
            </div>

        </>
    );
}

export default WelcomeWelcome;